import { Edit } from 'lucide-react';
import React from 'react';
import { IconButton, FormDrawer } from '../../ui';
import FormUserUpdate from '../Forms/FormUserUpdate';

export default function UpdateUser(props: { user: any, handleFunction: any }) {
    const [open, setOpen] = React.useState(false);

    return (
        <div>
            <IconButton tooltip="Modifier cet utilisateur" size={28} color="warning" onClick={() => setOpen(true)}><Edit size={16} /></IconButton>
            <FormDrawer
                open={open}
                onClose={() => setOpen(false)}
                title={`Modification de l'utilisateur ${props.user?.Name || ''}`}
                hint="Les informations existantes sont pré-remplies. Modifiez les champs souhaités puis enregistrez."
            >
                <FormUserUpdate handleFunction={() => { setOpen(false); props.handleFunction() }} user={props.user} />
            </FormDrawer>
        </div>
    );
}
